<template>
  <div class="form-group">
    <label>{{ question.statement }}</label>
    <select class="form-control" @change="onBooleanAnswerChange" :value="getBooleanAnswerValue()" :disabled="disabledAttribute">
      <option :value="'true'">Sim</option>
      <option :value="'false'">Não</option>
    </select>
    <p class="text-red" v-if="m_error">{{ m_error }}</p>
    <div class="row" v-if="getBooleanAnswerValue()">
      <div class="col-xs-12">
        <div class="box box-solid box-primary">
          <div class="box-body">
            <component
              v-for="field in question.fieldsWhenTrue"
              v-bind:key="field.uuid"
              ref="fields"
              v-on:fieldUpdated="onFieldUpdated"
              :is="getFieldComponent(field)"
              :field="field"
              :fieldAnswer="getFieldAnswer(field)"
              :isDisabled="disabledAttribute"
            >
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CNPJField from './fields/CNPJField'
import StringField from './fields/StringField'
import YearField from './fields/YearField'
import EmailField from './fields/EmailField'
import PhoneNumberField from './fields/PhoneNumberField'
import MultipleChoiceField from './fields/MultipleChoiceField'
import IntegerField from './fields/IntegerField'

export default {
  name: 'BooleanFormQuestion',
  props: ['question', 'answer', 'isDisabled'],
  data () {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: {
          booleanAnswer: this.answer.value && this.answer.value.booleanAnswer !== null ? this.answer.value.booleanAnswer : null,
          fieldsAnswersWhenTrue: this.answer.value && this.answer.value.fieldsAnswersWhenTrue ? this.answer.value.fieldsAnswersWhenTrue : []
        }
      },
      m_error: null,
      componentsPerType: {
        'cnpj': CNPJField,
        'string': StringField,
        'year': YearField,
        'email': EmailField,
        'phone_number': PhoneNumberField,
        'multiple-choice': MultipleChoiceField,
        'integer': IntegerField
      }
    }
  },
  computed: {
    disabledAttribute () {
      return this.question.disabled === true || this.isDisabled === true
    }
  },
  watch: {
    'm_answer.value': {
      handler () {
        this.$emit('answerUpdated', { 'questionUuid': this.question.uuid, 'value': this.m_answer.value })
      },
      deep: true
    }
  },
  mounted () {
    this.question = this.sortQuestionFieldsByRenderingOrder(this.question)
  },
  methods: {
    sortQuestionFieldsByRenderingOrder (question) {
      question.fieldsWhenTrue.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder
      })
      return question
    },
    onBooleanAnswerChange (data) {
      this.m_answer.value.booleanAnswer = (data.target.value === 'true')
      if (!this.m_answer.value.booleanAnswer) {
        this.m_answer.value.fieldsAnswersWhenTrue = []
      }
    },
    getBooleanAnswerValue () {
      return this.m_answer.value.booleanAnswer
    },
    getFieldComponent (f) {
      return this.componentsPerType[f.type]
    },
    onFieldUpdated (rowIndex, newFieldAnswer) {
      for (let i in this.m_answer.value.fieldsAnswersWhenTrue) {
        if (this.m_answer.value.fieldsAnswersWhenTrue[i].fieldUuid === newFieldAnswer.fieldUuid) {
          this.m_answer.value.fieldsAnswersWhenTrue[i] = newFieldAnswer
          return
        }
      }

      this.m_answer.value.fieldsAnswersWhenTrue.push({ fieldUuid: newFieldAnswer.fieldUuid, value: newFieldAnswer.value })
    },
    getFieldAnswer (field) {
      for (let i in this.m_answer.value.fieldsAnswersWhenTrue) {
        if (this.m_answer.value.fieldsAnswersWhenTrue[i].fieldUuid === field.uuid) {
          return { fieldUuid: this.m_answer.value.fieldsAnswersWhenTrue[i].fieldUuid, value: this.m_answer.value.fieldsAnswersWhenTrue[i].value }
        }
      }

      return { fieldUuid: field.uuid, value: null }
    },
    isValid () {
      this.m_error = null

      if (this.question.required && this.m_answer.value.booleanAnswer === null) {
        this.m_error = 'Esta campo é de preenchimento obrigatório'
        return false
      }

      let areFieldAnswersBlank = true
      for (let field in this.m_answer.value.fieldsAnswersWhenTrue) {
        if (this.m_answer.value.fieldsAnswersWhenTrue[field].value) {
          areFieldAnswersBlank = false
        }
      }
      if (!this.question.required && areFieldAnswersBlank) {
        this.m_answer.value.fieldsAnswersWhenTrue = []
        return true
      }

      if (!this.$refs.fields) {
        return true
      }

      let areFieldAnswersValid = true
      this.$refs.fields.forEach(f => {
        if (!f.isValid()) {
          areFieldAnswersValid = false
        }
      })

      return areFieldAnswersValid
    }
  }
}
</script>



// WEBPACK FOOTER //
// BooleanFormQuestion.vue?6e08bd6d